import Commands from "./commands";
import QueryFactory from "../query-factory";

class Query extends Commands {
    constructor(registry) {
        super("query", registry);
    }

    async execute(node, emitter, options) {
        const queryName = await emitter(node.params[0], options);
        const queryParams = [];
        for (let index = 1; index < node.params.length; index++) {
            queryParams.push(await emitter(node.params[index], options));
        }
        return QueryFactory.executeQuery(queryName, queryParams, options);
    }
}

export default Query;
